const AuthRoutes = {
  login: "/auth/dashboard/login",
  register: "/auth/register",
  changePassword: "/auth/changePassword",
};

export default AuthRoutes